/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportUrl
 */
export interface ReportUrl {
}

/**
 * Check if a given object implements the ReportUrl interface.
 */
export function instanceOfReportUrl(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReportUrlFromJSON(json: any): ReportUrl {
    return ReportUrlFromJSONTyped(json, false);
}

export function ReportUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportUrl {
    return json;
}

export function ReportUrlToJSON(value?: ReportUrl | null): any {
    return value;
}

